(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/assertThisInitialized", "@babel/runtime/helpers/defineProperty", "react", "noform/lib/context/dialogForm"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/assertThisInitialized"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("noform/lib/context/dialogForm"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.getPrototypeOf, global.inherits, global.assertThisInitialized, global.defineProperty, global.react, global.dialogForm);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _getPrototypeOf2, _inherits2, _assertThisInitialized2, _defineProperty2, _react, _dialogForm) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireDefault(_react);
  _dialogForm = _interopRequireDefault(_dialogForm);

  var DialogContent =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(DialogContent, _React$Component);

    function DialogContent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, DialogContent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DialogContent).call(this, props));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOnMount", function (core) {
        var onMount = _this.props.onMount;

        if (core) {
          onMount(core);

          _this.setState({
            core: core
          });
        }
      });
      _this.state = {
        core: null
      };
      return _this;
    }

    (0, _createClass2.default)(DialogContent, [{
      key: "render",
      value: function render() {
        var core = this.state.core;
        var _this$props = this.props,
            children = _this$props.children,
            footer = _this$props.footer;
        return _react.default.createElement(_dialogForm.default.Provider, {
          value: {
            onDialogMount: this.handleOnMount,
            dialogFooter: footer
          }
        }, children, core ? null : footer());
      }
    }]);
    return DialogContent;
  }(_react.default.Component);

  var _default = DialogContent;
  _exports.default = _default;
});